import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import pdfAutomatizacion from "../../static/media/productos/CATALOGO-ELECTRICA-GRM.pdf";
import pdfPiezas from "../../static/media/productos/Catalogo-VETO-2022.pdf";
import pdfIluminacion from "../../static/media/productos/CATALOGO-2022-LEDVANCE.pdf";
import BancoIcon from "../../static/media/home/Banco.webp";
import EnvioIcon from "../../static/media/home/Envio.webp";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  navyDark: "#003D73",
  gold: "#FFCD00",
  goldDark: "#E6B800",
  teal: "#5BC8AF",
  gray: "#F5F7FA",
  white: "#ffffff",
};

const CATALOGOS = [
  { id: 1, titulo: "Automatización", archivo: pdfAutomatizacion },
  { id: 2, titulo: "Piezas Eléctricas", archivo: pdfPiezas },
  { id: 3, titulo: "Iluminación", archivo: pdfIluminacion },
];

export default function Catalogos() {
  return (
    <Box
      id="catalogos-beneficios"
      sx={{
        background: `linear-gradient(180deg, ${C.navy} 0%, ${C.navyDark} 100%)`,
        pt: { xs: "64px", md: "88px" },
        pb: 0,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          width: "100%",
          px: { xs: "20px", sm: "32px", md: "40px" },
          boxSizing: "border-box",
        }}
      >
        {/* Catálogos */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{ textAlign: "center", mb: { xs: 6, md: 9 } }}
        >
          <Typography
            variant="h2"
            sx={{
              color: C.white,
              fontWeight: 900,
              fontSize: { xs: 26, sm: 32, md: 40 },
              letterSpacing: "-.02em",
              lineHeight: 1.12,
              mb: { xs: 4, md: 6 },
            }}
          >
            Descarga nuestros Catálogos
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: { xs: "12px", md: "16px" },
            }}
          >
            {CATALOGOS.map((cat, i) => (
              <Box
                key={cat.id}
                component={motion.a}
                href={cat.archivo}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                whileHover={{ scale: 1.04, y: -4 }}
                whileTap={{ scale: 0.96 }}
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  background: C.gold,
                  color: C.dark,
                  px: { xs: "20px", md: "28px" },
                  py: { xs: "12px", md: "14px" },
                  borderRadius: "50px",
                  textDecoration: "none",
                  fontWeight: 800,
                  fontSize: { xs: "13px", md: "15px" },
                  boxShadow: "0 10px 25px rgba(255,205,0,0.30)",
                  transition: "background .2s",
                  "&:hover": { background: C.goldDark },
                }}
              >
                <PictureAsPdfIcon sx={{ fontSize: { xs: 20, md: 22 } }} />
                {cat.titulo}
              </Box>
            ))}
          </Box>
        </Box>

        {/* Tarjetas de beneficios */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: "20px", md: "24px" },
            alignItems: "stretch",
          }}
        >
          {[
            {
              icon: BancoIcon,
              bg: `${C.gold}22`,
              title: "Pagos Seguros",
              text: "¡Aceptamos transferencias bancarias directas!",
            },
            {
              icon: EnvioIcon,
              bg: `${C.teal}22`,
              title: "Cobertura Total",
              text: "¡Envíos a nivel nacional y entregas en Quito!",
            },
          ].map((b, i) => (
            <Box
              key={b.title}
              component={motion.div}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.15 }}
              sx={{
                background: C.white,
                borderRadius: "20px",
                p: { xs: "22px 18px", md: "28px 24px" },
                flex: 1,
                boxShadow: "0 8px 28px rgba(0,0,0,.14)",
                display: "flex",
                alignItems: "center",
                gap: { xs: 2, md: 3 },
              }}
            >
              <Box
                sx={{
                  width: 62,
                  height: 62,
                  borderRadius: "14px",
                  background: b.bg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Box
                  component="img"
                  src={b.icon}
                  alt={b.title}
                  sx={{ width: 54, height: 54, objectFit: "contain" }}
                />
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: C.dark,
                    fontWeight: 800,
                    fontSize: { xs: 16, md: 19 },
                    mb: 0.5,
                  }}
                >
                  {b.title}
                </Typography>
                <Typography
                  sx={{
                    color: "#5c6c7a",
                    fontSize: { xs: 13, md: 14.5 },
                    lineHeight: 1.55,
                  }}
                >
                  {b.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Unión con Footer (dark) */}
      <Box
        sx={{
          height: { xs: "120px", md: "180px" },
          background: `linear-gradient(180deg, ${C.navyDark} 0%, ${C.dark} 100%)`,
          mt: { xs: 7, md: 10 },
        }}
      />
    </Box>
  );
}
